export default "__VITE_ASSET__Dnleb0sL__"